import React from "react";
import { array, bool, object, string } from "prop-types";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import Excerpt from "../../atoms/Excerpt";
import PublishedAt from "../../atoms/PublishedAt";

import { getExcerpt } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./wideStoryCard.m.css";

const WideStoryCard = ({
  story,
  widths = [650],
  imageType = "image16x9",
  aspectRatio = [16, 9],
  excerptShow = true,
  className = "",
}) => {
  if (!story) return null;

  const { mobile } = useDevice();

  const excerpt = excerptShow ? getExcerpt(story) : "";

  return (
    <div styleName="base" className={`wide-story-card ${className}`}>
      <div styleName="wrapper" style={{ paddingTop: `${(aspectRatio[1] / aspectRatio[0]) * 100}%` }}>
        <div styleName="card-image">
          <CardImage
            className="card-with-image-zoom"
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={widths}
            linkEnable={true}
          />
        </div>
        <div styleName="story-data" className="story-data">
          <div styleName="headline-excerpt" className="headline-excerpt">
            <NewsHeadline story={story} />
            {!mobile && <Excerpt excerpt={excerpt} url={story.url} />}
            <PublishedAt date={story["last-published-at"]} />
          </div>
        </div>
      </div>
    </div>
  );
};

WideStoryCard.propTypes = {
  story: object.isRequired,
  widths: array,
  imageType: string,
  aspectRatio: array,
  cssStyleName: string,
  excerptShow: bool,
  className: string,
};

export default WideStoryCard;
